import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DoctorSocialService } from '../doctor-social.service';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { ReportDialogComponent } from '../report-dialog/report-dialog.component';
import { Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-others-feed-options-dialog',
  templateUrl: './others-feed-options-dialog.component.html',
  styleUrls: ['./others-feed-options-dialog.component.css']
})
export class OthersFeedOptionsDialogComponent implements OnInit {

  postDetails;

  postStatusForDialogClose = null

  constructor(
    public dialogRef: MatDialogRef<OthersFeedOptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private service: DoctorSocialService,
    private toaster: ToastrService,
    public app: AppService,
    private Router: Router,
    private clipboard: Clipboard,
  ) { }

  ngOnInit(): void {
    this.getPostById();
  }

  getPostById() {
    this.service.getPostById(this?.data).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.postDetails = res.data
          // this.addParamsToUrl();
        } else if (res.errorCode != 0) {
          if (res.data.data.length == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      }
    )
  }

  dismiss() {
    this.dialogRef.close(this.postStatusForDialogClose);
    // this.removeParamsFromUrl();
    // setTimeout(() => {
    // }, 100);
  }

  saveUnSave() {
    if (!this?.postDetails?.iSavedPost) {
      this.service.savePost(this?.postDetails?.postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.success("Saved Successfully");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.success("تم الحفظ");
            }
            this.postStatusForDialogClose = "save"
            this.dismiss();
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    } else if (this?.postDetails?.iSavedPost) {
      this.service.unSavePost(this?.postDetails?.postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.success("Unsaved Successfully");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.success("تم إلغاء الحفظ");
            }
            this.postStatusForDialogClose = "unsave"
            this.dismiss();
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    }
  }

  interested() {
    if (!this?.postDetails?.iAmInterested) {
      this.service.interestedPost(this?.postDetails?.postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.success("Interested Successfully");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.success("تم الاهتمام");
            }
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
          this.dismiss();
        }
      )
    } else if (this?.postDetails?.iAmInterested) {
      this.service.unInterestedPost(this?.postDetails?.postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.success("Uninterested Successfully");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.success("تم إلغاء الاهتمام");
            }
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
          this.dismiss();
        }
      )
    }
  }

  copyLink() {
    let req = {
      "dynamicLinkInfo": {
        "domainUriPrefix": `https://ihospitalapp.page.link`,
        "link": `https://www.ihospitalapp.com/en/Tebgram/post/${this?.postDetails?.postId}`,
        "androidInfo": {
          "androidPackageName": "com.technzone.ihospital"
        },
        "iosInfo": {
          "iosBundleId": "com.technzone.ihospitalapp"
        }
      }
    }
    this.service.createDynamicLink(req).subscribe(
      res => {
        let link = res?.shortLink
        this.clipboard.copy(link);
        if (this?.app?.getUserLanguage() == 'en') {
          this.toaster.info("Link Copied");
        } else if (this?.app?.getUserLanguage() == 'ar') {
          this.toaster.info("تم نسخ الرابط");
        }
        this.dismiss();
      }
    )
  }

  // removeParamsFromUrl() {
  //   this.Router.navigate([], {
  //     queryParams: {
  //       'feedId': null,
  //     },
  //     queryParamsHandling: 'merge'
  //   });
  // }

  // addParamsToUrl() {
  //   this.Router.navigate([], {
  //     queryParams: {
  //       'feedId': this?.postDetails?.postId,
  //     },
  //     queryParamsHandling: 'merge'
  //   });
  // }

  reportPost() {
    let id = this?.data
    const dialogRef = this.dialog.open(ReportDialogComponent, {
      width: '33%',
      data: { id },
      panelClass: 'modalBoxScroll'
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == true) {

      }
    });
    this.dismiss();
  }

}
